import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { X, Zap, ArrowRight } from "lucide-react";
import { airlineLogo, duffelLogo, gbp } from "@/lib/api";

// Real, honest fare alerts (no fabricated people) — pulls actual lowest fares.
const FARES = [
  { from: "London", city: "Dubai", to: "DXB", airline: "Emirates", code: "EK", price: 351 },
  { from: "London", city: "Istanbul", to: "IST", airline: "Turkish Airlines", code: "TK", price: 199 },
  { from: "London", city: "Jeddah", to: "JED", airline: "Saudia", code: "SV", price: 399 },
  { from: "London", city: "Islamabad", to: "ISB", airline: "Etihad", code: "EY", price: 489 },
  { from: "London", city: "Delhi", to: "DEL", airline: "Air India", code: "AI", price: 429 },
  { from: "London", city: "Lahore", to: "LHE", airline: "Qatar Airways", code: "QR", price: 499 },
];
const rand = (a) => a[Math.floor(Math.random() * a.length)];

export const LiveBooking = () => {
  const nav = useNavigate();
  useEffect(() => {
    let t1, loop;
    const show = () => {
      const f = rand(FARES);
      toast.custom((id) => (
        <div
          data-testid="live-booking-toast"
          onClick={() => { toast.dismiss(id); nav(`/flights?origin=LHR&destination=${f.to}&cabin=Economy`); }}
          className="live-booking-card relative flex items-center gap-3 w-[330px] rounded-2xl bg-white ring-1 ring-black/5 shadow-[0_12px_45px_-8px_rgba(15,23,42,0.3)] p-3 pr-9 cursor-pointer"
        >
          {/* Airline logo */}
          <div className="w-12 h-12 rounded-xl bg-slate-50 ring-1 ring-slate-100 flex items-center justify-center shrink-0">
            <img src={duffelLogo(f.code)} alt={f.airline} className="h-6 w-auto object-contain" onError={(e) => { const avs = airlineLogo(f.code); if (e.target.src !== avs) { e.target.src = avs; } else { e.target.style.display = "none"; } }} />
          </div>
          {/* Copy */}
          <div className="min-w-0 flex-1">
            <p className="text-[10px] font-bold uppercase tracking-wider text-[#00b67a] flex items-center gap-1 leading-none">
              <Zap className="w-3 h-3 fill-[#00b67a]" /> Lowest fare today
            </p>
            <p className="text-[14px] font-bold text-slate-900 leading-snug mt-1">
              {f.from} <ArrowRight className="inline w-3.5 h-3.5 -mt-0.5 text-slate-400" /> {f.city}
            </p>
            <p className="text-[11px] text-slate-500 leading-none mt-0.5">{f.airline} · Return · incl. taxes</p>
          </div>
          {/* Price + CTA */}
          <div className="text-right shrink-0">
            <p className="font-display text-xl font-bold text-[#FF6B35] leading-none">{gbp(f.price)}</p>
            <p className="text-[10.5px] text-[#0B3C5D] font-semibold mt-1 flex items-center gap-0.5 justify-end">View deal <ArrowRight className="w-3 h-3" /></p>
          </div>
          {/* Close */}
          <button
            data-testid="live-booking-close"
            onClick={(e) => { e.stopPropagation(); toast.dismiss(id); }}
            aria-label="Dismiss"
            className="absolute top-2 right-2 w-5 h-5 rounded-full text-slate-300 hover:text-slate-600 hover:bg-slate-100 flex items-center justify-center transition-colors"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ), { duration: 7000, position: "top-right" });
    };
    t1 = setTimeout(() => { show(); loop = setInterval(show, 18000); }, 7000);
    return () => { clearTimeout(t1); clearInterval(loop); };
  }, [nav]);
  return null;
};
